export enum PatientWeightUnit {
  Pound = 'lb',
  Kilogram = 'kg',
}
